





























































































































































































import {Component, Prop} from 'vue-property-decorator'
import BridgeTargetSection from '@/components/BridgeTargetSection.vue'
import BridgeProceedButton from '@/components/BridgeProceedButton.vue'
import BridgeTokenSelection, {
  BridgeTokenOption,
} from '@/components/BridgeTokenSelection.vue'
import BridgeDisclaimerMobile from '@/components/BridgeDisclaimerMobile.vue'
import BridgeSourceSection from '@/components/BridgeSourceSection.vue'
import {$} from '@/facade'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

@Component({
  components: {
    BridgeSourceSection,
    BridgeDisclaimerMobile,
    BridgeTokenSelection,
    BridgeProceedButton,
    BridgeTargetSection,
  },
})
export default class BridgeTransferSection extends MixinScreenSize {
  @Prop({required: true}) selectedToken!: BridgeTokenOption
  @Prop({type: Array, required: true}) tokenOptions!: BridgeTokenOption[]
  @Prop({type: Number, required: true}) selectedTokenDecimals!: number
  @Prop({type: String, required: true}) sourceNetwork!: string
  @Prop({type: String, required: true}) targetNetwork!: string
  @Prop({type: String, required: true}) sourceAmount!: string
  @Prop({type: String, required: true}) targetAmount!: string
  @Prop({type: Boolean, required: true}) isMaxAmountSelected!: boolean
  @Prop({type: String, required: true}) maxAmount!: string
  @Prop({type: String, required: true}) bridgeFeeAmount!: string
  @Prop({type: String, required: true}) receivedAmountFormatted!: string
  @Prop({type: Boolean, required: true}) isProceedButtonDisabled!: boolean
  @Prop({type: String, required: true}) popoverText!: string
  @Prop({type: Boolean, default: false}) isSwapping!: boolean
  @Prop({type: Boolean, default: false}) balanceUnavailable!: boolean
  @Prop({type: String, default: ''}) balanceUnavailableMessage!: string

  isMobileDisclaimerOpened = false

  get isNeoXSource() {
    return this.sourceNetwork === 'X'
  }

  handleSelectToken(token: BridgeTokenOption) {
    this.$emit('token-selected', token)
  }

  openConnectWalletModal(networkNamespace: string) {
    $.modal.open('connectWalletModal', {
      networkNamespace,
    })
  }

  handleChangeSourceAmount(amount: number) {
    this.$emit('input', amount)
  }

  handleMaxClick() {
    this.$emit('max')
  }

  swapNetworks() {
    this.$emit('swap-networks')
  }

  handleBridgeClick() {
    if (this.isProceedButtonDisabled) {
      this.isMobileDisclaimerOpened = !this.isMobileDisclaimerOpened
      return
    }

    $.modal.open('bridgeModal', {
      sourceNetwork: this.sourceNetwork,
      amount: this.targetAmount,
      selectedToken: this.selectedToken,
      isMaxAmountSelected: this.isMaxAmountSelected,
    })
  }
}
